import actions from "@/modules/job-schedules/store/actions"
import mutations from "@/modules/job-schedules/store/mutations"

const state = () => ({
  syncJobSchedules: {},
  feedJobSchedules: {},
})

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
